<template>
  <div class="label text-black text-sm leading-none relative border border-black rounded m-1">
    <div class="label-payment-received absolute pin flex justify-center items-center overflow-hidden font-mono" v-if="entry.order.payment_received">
      <span class="text-5xl font-bold uppercase border-2 border-black px-2 rounded-lg">Payé</span>
    </div>
    <div class="label-order-number absolute text-center font-mono">
      <span class="border border-black px-1" v-text="entry.order.order_number"></span>
    </div>
    <div class="flex justify-between border-b border-black mb-1">
      <span class="font-bold whitespace-no-wrap" v-text="entry.order.cart.customer.name"></span>
      <span class="font-mono" v-text="`${pickupDate}${pickupTime ? ` ${pickupTime}` : '' }${entry.order.shop ? ` ${entry.order.shop.code}`: '' }`"></span>
      <span class="font-mono" v-text="entry.label_number"></span>
    </div>
    <div class="mr-4 pr-1">
      <div v-for="(product, index) in entry.products" :key="index" class="mr-1 inline">
          <span class="whitespace-no-wrap">
            <svgicon name="cupcake-solid"/> {{ product.name }} x {{ product.pivot.quantity }}
          </span>
          <em v-if="product.pivot.note" class="text-xs">({{ product.pivot.note }})</em>
      </div>
    </div>
  </div>
</template>


<script>
/* globals moment */
import { ucfirst } from '../../core/helpers';

export default {
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },

  computed: {
    pickupDate() {
      return ucfirst(
        moment(this.entry.order.pickup_date).format('ddd DD/MM'),
      ).replace('.', '');
    },

    pickupTime() {
      if (!this.entry.order.pickup_time) {
        return null;
      }
      return moment(this.entry.order.pickup_time, 'HH:mm:ss').format('HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  width: 99mm;
  height: 34mm;
  padding: 2mm;
}

.label-order-number {
  width: 26mm;
  right: 2mm;
  top: 7mm;
  bottom: 0;
  transform: rotate(90deg);
}

.label-order-shop {
  width: 26mm;
  right: 2mm;
  top: 7mm;
  bottom: 0;
}

.label-payment-received {
  span {
    opacity: 0.1;
    transform: rotate(-30deg);
  }
}

svg {
  position: relative;
  top: 2px;
}

@media print {
  .label {
    border: none;
    margin: 0;

    &:nth-child(odd) {
      margin-right: 2mm;
    }
  }
}
</style>
